import React, { useState, useEffect, useContext } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { secondsToMilliseconds } from "date-fns";
import { cibOpenCollective } from "@coreui/icons";
import { PlayIcon } from "@heroicons/react/outline";
import ReactTooltip from "react-tooltip";
import Enregistrement from "./Enregistrement";
import { useTranslation, withTranslation } from "react-i18next";

const compte = localStorage.getItem("compte");
const poste = localStorage.getItem("poste");
const token = localStorage.getItem("AccessToken");
function Contactappel(props) {
  const { t } = useTranslation("common");

  /************************************Date en 11/11/1111************************* */
  const formatDate = (dateString) => {
    var allDate = dateString.split(" ");
    var thisDate = allDate[0].split("-");
    var thisTime = allDate[1].split(":");
    var newDate = [thisDate[2], thisDate[1], thisDate[0]].join("-");

    var suffix = thisTime[0] >= 12 ? "PM" : "AM";
    var hour = thisTime[0] > 12 ? thisTime[0] - 12 : thisTime[0];
    var Datefinal = " Le" + newDate + " " + "à" + " " + allDate[1];
    return Datefinal;
  };

  const today = (dateString) => {
    let today = new Date(dateString).setHours(0, 0, 0, 0);
    let yesterday = new Date();
    let yesterdayoftoday = yesterday.setDate(yesterday.getDate() - 1);

    let yesterday2 = new Date(yesterdayoftoday).setHours(0, 0, 0, 0);

    let d2 = new Date(dateString);
    let d1 = new Date();
    let d11 = d1.setHours(0, 0, 0, 0);

    let d22 = d2.setHours(0, 0, 0, 0);

    if ((d11.valueOf() == d22.valueOf()) == true) {
      var allDate = dateString.split(" ");
      var Datefinal = t("aujourdhui") + t("at") + " " + allDate[1];
      return Datefinal;
    }
    if ((yesterday2.valueOf() == today.valueOf()) == true) {
      var allDate = dateString.split(" ");
      var Datefinal = t("hier") + t("at") + " " + allDate[1];
      return Datefinal;
    } else {
      var allDate = dateString.split(" ");
      var thisDate = allDate[0].split("-");
      var thisTime = allDate[1].split(":");
      var newDate = [thisDate[2], thisDate[1], thisDate[0]].join("/");

      var suffix = thisTime[0] >= 12 ? "PM" : "AM";
      var hour = thisTime[0] > 12 ? thisTime[0] - 12 : thisTime[0];
      var Datefinal = t("le") + newDate + " " + t("at") + " " + allDate[1];
      return Datefinal;
    }
  };
  ////**********************************etat d'appel icons**************** */
  const icon = (disposition, src, dst) => {
    if (src === poste) {
      if (disposition === "ANSWERED") {
        return (
          <div data-tip data-for="émis">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-5 w-5 text-blue-500"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M16 3h5m0 0v5m0-5l-6 6M5 3a2 2 0 00-2 2v1c0 8.284 6.716 15 15 15h1a2 2 0 002-2v-3.28a1 1 0 00-.684-.948l-4.493-1.498a1 1 0 00-1.21.502l-1.13 2.257a11.042 11.042 0 01-5.516-5.517l2.257-1.128a1 1 0 00.502-1.21L9.228 3.683A1 1 0 008.279 3H5z"
              />
            </svg>
            <ReactTooltip id="émis" place="bottom" effect="solid">
              {t("appelemis")}
            </ReactTooltip>
          </div>
        );
      } else if (disposition === "NO ANSWER") {
        return (
          <div data-tip data-for="émis2">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-5 w-5 text-gray-400"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M16 3h5m0 0v5m0-5l-6 6M5 3a2 2 0 00-2 2v1c0 8.284 6.716 15 15 15h1a2 2 0 002-2v-3.28a1 1 0 00-.684-.948l-4.493-1.498a1 1 0 00-1.21.502l-1.13 2.257a11.042 11.042 0 01-5.516-5.517l2.257-1.128a1 1 0 00.502-1.21L9.228 3.683A1 1 0 008.279 3H5z"
              />
            </svg>
            <ReactTooltip id="émis2" place="bottom" effect="solid">
              {t("appelemis")}
            </ReactTooltip>
          </div>
        );
      } else {
        return (
          <div data-tip data-for="échoué">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-5 w-5 text-red-500"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636"
              />
            </svg>
            <ReactTooltip id="échoué" place="bottom" effect="solid">
              {t("failedcall")}
            </ReactTooltip>
          </div>
        );
      }
    }

    if (src !== poste) {
      if (disposition === "ANSWERED") {
        return (
          <div data-tip data-for="recu">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-5 w-5 text-green-600"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M21 3l-6 6m0 0V4m0 5h5M5 3a2 2 0 00-2 2v1c0 8.284 6.716 15 15 15h1a2 2 0 002-2v-3.28a1 1 0 00-.684-.948l-4.493-1.498a1 1 0 00-1.21.502l-1.13 2.257a11.042 11.042 0 01-5.516-5.517l2.257-1.128a1 1 0 00.502-1.21L9.228 3.683A1 1 0 008.279 3H5z"
              />
            </svg>
            <ReactTooltip id="recu" place="bottom" effect="solid">
              {t("appelrecu")}
            </ReactTooltip>
          </div>
        );
      } else {
        return (
          <div data-tip data-for="manqué">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-5 w-5 text-red-700"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M16 8l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2M5 3a2 2 0 00-2 2v1c0 8.284 6.716 15 15 15h1a2 2 0 002-2v-3.28a1 1 0 00-.684-.948l-4.493-1.498a1 1 0 00-1.21.502l-1.13 2.257a11.042 11.042 0 01-5.516-5.517l2.257-1.128a1 1 0 00.502-1.21L9.228 3.683A1 1 0 008.279 3H5z"
              />
            </svg>
            <ReactTooltip id="manqué" place="bottom" effect="solid">
              {t("appel.manque")}
            </ReactTooltip>
          </div>
        );
      }
    }
  };

  const [showModal, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [showModal2, setShow2] = useState(false);

  const handleClose2 = () => setShow2(false);
  const handleShow2 = () => setShow2(true);
  const [nom, SetNom] = useState("");
  const [numero, Setnumero] = useState("");

  // const [Nameappel, Setameappel] = useState("Inconnu");

  const appel = (collegue) => {
    if (collegue.src == poste) {
      // Setnumero(collegue.dst);
      return <div class="text-sm leading-5 text-gray-500">{collegue.dst}</div>;
    } else {
      // Setameappel(collegue.src);
      return <div class="text-sm leading-5 text-gray-500">{collegue.src}</div>;
    }
  };
  //////////////////////////////////////////////Names With fetch /////////////////////////

  const Playiconsdisabled = (idenregistrement) => {
    if (idenregistrement === "") {
      return (
        <div
          data-tip
          data-for="playTip"
          class="dark:bg-gray-600 inline-flex items-center p-2 border rounded-full border-transparent shadow-sm text-xs font-medium text-gray-500 bg-gray-100 hover:text-green-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-600"
        >
          <ReactTooltip id="playTip" place="bottom" effect="solid">
            {t("pasenregistrement")}
          </ReactTooltip>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="h-5 w-5  text-gray-300 dark:text-gray-700"
            viewBox="0 0 20 20"
            fill="currentColor"
          >
            <path
              fillRule="evenodd"
              d="M10 18a8 8 0 100-16 8 8 0 000 16zM9.555 7.168A1 1 0 008 8v4a1 1 0 001.555.832l3-2a1 1 0 000-1.664l-3-2z"
              clipRule="evenodd"
            />
          </svg>
        </div>
      );
    } else {
      return (
        <button
          data-tip
          data-for="play2Tip"
          type="button"
          onClick={handleShow}
          class="dark:bg-gray-600 inline-flex items-center p-2 border rounded-full border-transparent shadow-sm text-xs font-medium text-gray-500 bg-gray-100 hover:text-green-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-600"
        >
          <ReactTooltip id="play2Tip" place="bottom" effect="solid">
            {t("ecouter")}
          </ReactTooltip>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="h-5 w-5 dark:text-white"
            viewBox="0 0 20 20"
            fill="currentColor"
          >
            <path
              fillRule="evenodd"
              d="M10 18a8 8 0 100-16 8 8 0 000 16zM9.555 7.168A1 1 0 008 8v4a1 1 0 001.555.832l3-2a1 1 0 000-1.664l-3-2z"
              clipRule="evenodd"
            />
          </svg>
        </button>
      );
    }
  };

  return (
    <tr className="dark:bg-gray-900 dark:text-white ">
      <td class="px-4 py-4 whitespace-no-wrap border-b border-gray-200  dark:border-gray-700">
        {icon(props.appel.disposition, props.appel.src, props.appel.dst)}

        <ReactTooltip id="callTip" place="bottom" effect="solid">
          {t("Appeler")}
        </ReactTooltip>
      </td>

      <td class="py-1 whitespace-no-wrap border-b border-gray-200 dark:border-gray-700">
        <div class="text-sm leading-5 text-gray-500 ml-2 inline-block dark:text-gray-300 ">
          {/* {today(props.appel.calldate_start)} */}
          {props.appel.calldate_start
            ? today(props.appel.calldate_start)
            : console.log("error")}
        </div>
      </td>
      <Enregistrement
        showModal={showModal}
        handleClose={handleClose}
        enregistrement={props.appel.id_enregistrement}
      />
      <td class="py-1 whitespace-no-wrap border-b border-gray-200 dark:border-gray-700">
        <span class="dark:bg-gray-600 dark:text-white px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800 dark:border-gray-700">
          {props.appel.billsec}
        </span>
      </td>
      <td class="py-1 px-4 whitespace-no-wrap border-b border-gray-200 text-sm leading-5 font-medium dark:border-gray-700">
        <div class="space-x-3">
          {/* {Playiconsdisabled(props.appel.id_enregistrement)} */}
        </div>
      </td>
    </tr>
  );
}
export default withTranslation("common")(Contactappel);
